import dataSetting from './dataSetting'
import surat from './surat'
import doa from './doa'
export default {
    dataSetting,
    surat,
    doa
}